import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { Mail } from "lucide-react";
import Inbox from "./index";

const inboxRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Inbox",
        basePath: "inbox",
        mainComponent: <Inbox />,
        layout: "/console",	   
        icon: <Mail className="icon-item" />,
        subTitle:"Inbox",
        level:5,
        moduleId: 0,
    })
]

export default inboxRoutes;